import CustomerInstallationListResourcePagingResultModel from '../../generated/types/model/resource/CustomerInstallationListResourcePagingResultModel';

export default class CustomerInstallationListResourcePagingResultViewModel extends CustomerInstallationListResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
